var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"image"},[_c('img',{style:({ backgroundColor: _vm.chosenRandomColor }),attrs:{"src":_vm.mImageSrc,"alt":_vm.itemName,"loading":"lazy"},on:{"error":_vm.handleError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }